/* Connects the mockup storefront to the real Shopify cart + checkout. */
(() => {
  const I = window.INC || {};
  // Native Shopify bundles: mat product handle -> tier -> mat variant id -> bundle variant id (fixed bundle price)
  const BMAP = {"the-dragons-palace-floor-mats":{"1":{"49218844328188":67985006592252,"49218844360956":67985006625020,"49218844393724":67985006657788},"2":{"49218844328188":67985006690556,"49218844360956":67985006723324,"49218844393724":67985006756092}},"the-oni-masks-floor-mats":{"1":{"67624488796412":67985006788860,"67624488829180":67985006821628,"67624488861948":67985006854396},"2":{"67624488796412":67985006887164,"67624488829180":67985006919932,"67624488861948":67985006952700}},"ichigo-bankai-x-hollow-form-limited-edition-floor-mats":{"1":{"51007579619580":67985006985468,"51007579652348":67985007018236,"51007579685116":67985007051004},"2":{"51007579619580":67985007083772,"51007579652348":67985007116540,"51007579685116":67985007149308}},"luffy-gear-5-limited-edition-floor-mat":{"1":{"47314839896316":67985007182076,"47314839929084":67985007214844,"47314839961852":67985007247612},"2":{"47314839896316":67985007476988,"47314839929084":67985007509756,"47314839961852":67985007542524}},"sharigan-manga-panel-floor-mat":{"1":{"47287637049596":67985007575292,"47287637082364":67985007608060,"47287637115132":67985007640828},"2":{"47287637049596":67985007673596,"47287637082364":67985007706364,"47287637115132":67985007739132}},"oni-mask-x-snake-japanese-tattoo-style-floor-mats":{"1":{"47339530420476":67985007804668,"47339530486012":67985007837436,"47339530518780":67985007870204,"47339530453244":67985007902972},"2":{"47339530420476":67985007935740,"47339530486012":67985007968508,"47339530518780":67985008001276,"47339530453244":67985008034044}},"luffy-zoro-floor-mats":{"1":{"47314855592188":67985008066812,"47314855624956":67985008099580,"47314855657724":67985008132348},"2":{"47314855592188":67985008165116,"47314855624956":67985008197884,"47314855657724":67985008230652}},"retro-playstation-floor-mats":{"1":{"48380956934396":67985008427260,"48380957032700":67985008460028,"48380957065468":67985008492796,"48380956967164":67985008525564,"48380956999932":67985008558332}},"dragon-x-koi-floor-mats":{"1":{"48965016584444":67985005936892,"48965016617212":67985005969660,"48965016649980":67985006002428},"2":{"48965016584444":67985008591100,"48965016617212":67985008623868,"48965016649980":67985008656636}},"kami-no-ichimatsu-series-red-checkered-floor-mat-set":{"1":{"47278223950076":67985010557180,"47278223982844":67985010589948,"47278224015612":67985010622716},"2":{"47278223950076":67985010655484,"47278223982844":67985010688252,"47278224015612":67985010721020}},"kitsune-x-geisha-floor-mats":{"1":{"47852848873724":67985010753788}},"berserk-you-cannot-escape-floor-mat-set":{"1":{"48697880445180":67985010786556,"48697880477948":67985010819324,"48697880510716":67985010852092},"2":{"48697880445180":67985010884860,"48697880477948":67985010917628,"48697880510716":67985010950396}}};
  // open the right view for pages that use the mockup layout
  if (!location.hash) {
    const p = location.pathname;
    if (/\/pages\/yokai/.test(p)) location.hash = '#yokai';
    else if (/\/pages\/genji/.test(p)) location.hash = '#genji';
  }
  // keep the cart drawer's checkout button clear of Shopify's theme-preview bar
  const pb = () => {
    const f = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
    const h = f ? Math.round(f.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--pbh', h + 'px');
  };
  const st = document.createElement('style');
  st.textContent = '.cdr{bottom:var(--pbh,0px)!important}';
  document.head.appendChild(st);
  [500, 1500, 3000, 6000].forEach(t => setTimeout(pb, t)); addEventListener('resize', pb);

  const toast = t => { const el = document.getElementById('toast'); if (el) { el.textContent = t; el.classList.add('on'); setTimeout(() => el.classList.remove('on'), 2400); } };
  const PJ = {};
  const pjs = h => PJ[h] || (PJ[h] = fetch('/products/' + encodeURIComponent(h) + '.js').then(r => r.ok ? r.json() : null).catch(() => null));
  const avail = p => p.variants.filter(v => v.available);
  const variantFor = async (handle, name) => {
    const p = await pjs(handle); if (!p) return null;
    const n = (name || '').toLowerCase(); const a = avail(p);
    const match = a.find(v => v.title !== 'Default Title' && n.includes(v.title.toLowerCase())) ||
      (/\brear\b/.test(n) && a.find(v => /rear/i.test(v.title))) || (/\b(front|driver)\b/.test(n) && a.find(v => /front|driver/i.test(v.title))) || a[0] || p.variants[0];
    return match && match.id;
  };
  const byName = async name => {
    const q = name.split(' · ')[0].replace(/\(.*?\)/g, '').trim();
    const r = await fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=1');
    if (!r.ok) return null; const j = await r.json(); const p = j.resources?.results?.products?.[0];
    return p ? variantFor(p.handle, name) : null;
  };

  // Kaching deal shown on a product page (fallback only, for any tier without a native bundle)
  const kach = async h => {
    try {
      const html = await (await fetch('/products/' + encodeURIComponent(h))).text();
      const m = html.match(/class="kaching-bundles-deal-block-settings"[^>]*>([\s\S]*?)<\/script>/);
      return m ? JSON.parse(m[1]) : null;
    } catch (_) { return null; }
  };
  const norm = s => (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  const KB = o => ({ __kaching_bundles: JSON.stringify(o) });
  const MATRX = { full: /full/i, front: /front|driver|passenger/i, rear: /rear|back/i };

  async function bundleItems(l) {
    const k = l.k, P = (window.MPX || {})[k.m];
    const mp = await pjs(k.m); if (!mp) return null;
    const a = avail(mp);
    const byIx = k.mi != null && mp.variants[k.mi] && mp.variants[k.mi].available ? mp.variants[k.mi] : null;
    const mv = byIx || a.find(v => v.title === k.v) || a.find(v => MATRX[k.mk] && MATRX[k.mk].test(v.title)) || a[0] || mp.variants[0];
    if (!k.t) return [{ id: mv.id, quantity: l.q || 1 }];
    // native bundle product for this design + tier + mat set
    const bv = BMAP[k.m] && BMAP[k.m][k.t] && BMAP[k.m][k.t][mv.id];
    if (bv) return [{ id: bv, quantity: l.q || 1 }];
    const bar = P && P.k3 && P.k3.bars[k.t - 1];
    const its = bar ? bar[5] : [];
    const comps = (await Promise.all(its.map(async ([x]) => {
      const [hh, vt] = x.split(':'); const p = await pjs(hh); if (!p) return null;
      const pa = avail(p); const v = (vt && pa.find(v => v.title === vt)) || pa[0] || p.variants[0];
      return { pid: p.id, vid: v.id };
    }))).filter(Boolean);
    const j = await kach(k.m);
    const bars = (j && j.dealBars) || [];
    const kb = bars.find(b => b.dealBarType === 'bundle' && bar && norm(b.title) === norm(bar[1])) ||
      (bars[k.t] && bars[k.t].dealBarType === 'bundle' ? bars[k.t] : null);
    const out = [];
    for (let n = 0; n < (l.q || 1); n++) {
      if (kb && j.nanoId) {
        const gid = Math.random().toString(36).slice(2, 6);
        out.push({ id: mv.id, quantity: 1, properties: KB({ deal: j.nanoId, pp: mp.id, main: true, id: gid, bar: kb.id }) });
        const pool = comps.slice();
        for (const bp of kb.bundleProducts || []) {
          if (bp.productGID === 'default') continue;
          const pid = +String(bp.productGID).split('/').pop();
          for (let q = 0; q < (bp.quantity || 1); q++) {
            const ix = pool.findIndex(c => c.pid === pid);
            let vid = null;
            if (ix >= 0) { vid = pool[ix].vid; pool.splice(ix, 1); }
            else if (bp.defaultVariantGID) vid = +String(bp.defaultVariantGID).split('/').pop();
            else if (bp.variantGIDs && bp.variantGIDs.length) vid = +String(bp.variantGIDs[0]).split('/').pop();
            if (vid) out.push({ id: vid, quantity: 1, properties: KB({ id: gid, deal: j.nanoId, bar: kb.id, bundleProduct: bp.id }) });
          }
        }
      } else {
        out.push({ id: mv.id, quantity: 1 });
        comps.forEach(c => out.push({ id: c.vid, quantity: 1 }));
      }
    }
    return out;
  }

  // floor-mat bundle data from the mockup page (const MP={...})
  if (!window.MPX) {
    try {
      for (const s of document.scripts) {
        const t = s.textContent; const i = t.indexOf('const MP='); if (i < 0) continue;
        let d = 0, q = false, esc = false, j = t.indexOf('{', i);
        for (let k = j; k < t.length; k++) {
          const c = t[k];
          if (q) { if (esc) esc = false; else if (c === '\\') esc = true; else if (c === '"') q = false; continue; }
          if (c === '"') q = true; else if (c === '{') d++; else if (c === '}') { d--; if (!d) { window.MPX = JSON.parse(t.slice(j, k + 1)); break; } }
        }
        break;
      }
    } catch (_) {}
  }
  // remember which mats + tier a bundle line is, so checkout can rebuild it
  const vis = id => { const v = document.getElementById(id); return v && !v.hidden; };
  const val = (sel, d) => (document.querySelector(sel) || { value: d }).value;
  const mkOf = txt => /rear/i.test(txt) ? 'rear' : /front/i.test(txt) ? 'front' : 'full';
  const guessK = () => {
    if (location.hash.startsWith('#p/')) {
      const m = decodeURIComponent(location.hash.split('/')[1] || '');
      const mi = document.querySelector('#v-pdp input[name="mtm"]:checked'), ti = document.querySelector('#v-pdp input[name="mtt"]:checked');
      if (!mi) return null;
      // mi = index of the chosen mat variant, so mixed sets map to the right bundle
      return { m, mk: mkOf(mi.closest('label').textContent), t: ti ? +ti.value : 0, mi: +mi.value };
    }
    if (vis('v-ryu')) return { m: 'dragon-x-koi-floor-mats', mk: val('#rmats input:checked', 'full'), t: +val('#rtiers input:checked', 0) };
    if (vis('v-oni')) return { m: 'the-oni-masks-floor-mats', mk: val('#omats input:checked', 'full'), t: +val('#tiers input:checked', 0) };
    return null;
  };
  const wrap = () => {
    const X = window.CARTX; if (!X || X.__w) return; X.__w = 1;
    const orig = X.named;
    X.named = function (n, p, inc, acc, k) {
      const r = orig.apply(this, arguments);
      try {
        const kk = k || guessK();
        if (kk) { const S = X.S(); const l = S.l.slice().reverse().find(x => x.n === n); if (l && !l.k) l.k = kk; }
      } catch (_) {}
      return r;
    };
  };
  wrap(); addEventListener('load', wrap); setTimeout(wrap, 1500);

  let busy = false;
  async function realCheckout(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (busy) return; busy = true;
    const X = window.CARTX; if (!X || !X.S) { location.href = '/checkout'; return; }
    const S = X.S(); const items = []; const skipped = [];
    toast('Taking you to secure checkout…');
    for (const l of S.l) {
      if (l.p < 0) continue;
      try {
        if (l.k && l.k.m) { const b = await bundleItems(l); if (b && b.length) { items.push(...b); continue; } }
        const id = l.h ? await variantFor(l.h, l.n) : await byName(l.n);
        if (id) items.push({ id, quantity: l.q || 1 }); else skipped.push(l.n);
      } catch (_) { skipped.push(l.n); }
    }
    let mys = 0;
    for (const g of S.g) {
      if (g === 'm') { mys++; continue; }
      const c = document.querySelector('[data-i="' + g + '"]');
      const h = c && c.dataset.h; if (h) { const id = await variantFor(h, ''); if (id) items.push({ id, quantity: 1 }); }
    }
    // each mystery freshener goes in as its own line, tagged with the design the customer pulled
    if (mys && I.mysteryVariant) {
      const R = (window.INCMYS && window.INCMYS()) || [];
      for (let k = 0; k < mys; k++) {
        const r = R[k];
        items.push(r && r.n ? { id: I.mysteryVariant, quantity: 1, properties: { 'Design': r.n } } : { id: I.mysteryVariant, quantity: 1 });
      }
    }
    try {
      /* Keep anything already in the real cart from regular product pages (e.g. Gengar): only replace what this
         homepage cart added last time (tagged _src=app), instead of clearing the whole cart. */
      const cur = await fetch('/cart.js').then(r => r.json()).catch(() => null);
      const upd = {};
      ((cur && cur.items) || []).forEach(it => { if (it.properties && it.properties._src === 'app') upd[it.key] = 0; });
      if (Object.keys(upd).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: upd }) });
      items.forEach(it => { it.properties = Object.assign({}, it.properties || {}, { _src: 'app' }); });
      if (items.length) {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); busy = false; toast(j.description || 'Something sold out. Please check your cart.'); location.href = '/cart'; return; }
      }
    } catch (_) {}
    location.href = '/checkout';
  }
  document.addEventListener('click', e => {
    const t = e.target.closest('#cgo, a[href="#checkout"], [data-checkout]');
    if (t) realCheckout(e);
  }, true);
  addEventListener('hashchange', () => { if (/^#(checkout|thanks)/.test(location.hash)) realCheckout(); });
})();

/* Mystery air freshener: revealed in the cart the moment it's unlocked.
   The design is locked to this browser, so removing and re-adding items brings back the same one. */
(() => {
  const RK = 'inc_mys_v1';
  const $ = id => document.getElementById(id);
  let R = [];
  try { const x = JSON.parse(localStorage.getItem(RK) || '[]'); if (Array.isArray(x)) R = x; } catch (_) {}
  const saveR = () => { try { localStorage.setItem(RK, JSON.stringify(R)); } catch (_) {} };
  window.INCMYS = () => R;

  // designs that can come out of the pack: single air fresheners only (no packs or sets)
  const NOPE = /pack|set|bundle|all of|crew|&| x .* x |complete|wanted posters|\d$/i;
  let POOL = null;
  const pool = () => {
    if (POOL && POOL.length) return POOL;
    const seen = new Set(), out = [];
    document.querySelectorAll('#mm-fresh .bi, #s-fresh .bi, #s-fresh .pc').forEach(e => {
      const b = e.querySelector('h3') || e.querySelector(':scope > b'), im = e.querySelector('img');
      const n = b ? b.textContent.trim().replace(/\s*air freshener$/i, '') : '';
      if (!n || !im || NOPE.test(n) || seen.has(n)) return;
      seen.add(n); out.push({ n, s: im.currentSrc || im.src });
    });
    POOL = out;
    return out;
  };
  const pick = () => {
    const P = pool(); if (!P.length) return { n: 'Mystery design', s: window.MYS || '' };
    const have = new Set(R.map(r => r.n));
    const fresh = P.filter(p => !have.has(p.n));
    const L = fresh.length ? fresh : P;
    const p = L[Math.floor(Math.random() * L.length)];
    return { n: p.n, s: p.s, seen: 0 };
  };
  const mysCount = () => { const X = window.CARTX; return X && X.S ? X.S().g.filter(g => g === 'm').length : 0; };

  /* ---------- reveal animation (trading-card pack) ---------- */
  const css = document.createElement('style');
  css.textContent = `
.mr-sc{position:fixed;inset:0;z-index:120;display:grid;place-items:center;background:rgba(0,0,0,.78);backdrop-filter:blur(6px);opacity:0;transition:opacity .25s}
.mr-sc.on{opacity:1}
.mr-st{display:grid;justify-items:center;gap:18px;padding:24px 16px;text-align:center;width:min(100%,360px)}
.mr-eb{font-family:var(--f-mono,monospace);font-size:11px;letter-spacing:.12em;text-transform:uppercase;color:var(--gold,#e3b04b)}
.mr-stage{position:relative;width:200px;height:280px;perspective:900px}
.mr-pack,.mr-card{position:absolute;inset:0;border-radius:16px}
.mr-pack{display:grid;place-items:center;background:linear-gradient(135deg,#2a2210,#e3b04b 35%,#fff3c4 50%,#e3b04b 65%,#2a2210);background-size:250% 250%;box-shadow:0 20px 60px rgba(227,176,75,.35);animation:mrfoil 2.2s linear infinite,mrshake .55s ease-in-out .35s 2;cursor:pointer;overflow:hidden;border:0;padding:0}
.mr-pack::before{content:"";position:absolute;inset:10px;border:2px solid rgba(0,0,0,.35);border-radius:10px}
.mr-pack b{font-family:var(--f-display,system-ui);font-size:86px;line-height:1;color:#141008;text-shadow:0 2px 0 rgba(255,255,255,.4)}
.mr-pack small{position:absolute;bottom:22px;left:0;right:0;font-family:var(--f-mono,monospace);font-size:10px;letter-spacing:.14em;color:#141008}
.mr-top{position:absolute;left:0;right:0;top:0;height:44px;background:inherit;border-bottom:2px dashed rgba(0,0,0,.4);border-radius:16px 16px 0 0}
.mr-sc.tear .mr-top{animation:mrtear .5s cubic-bezier(.3,.7,.4,1) forwards}
.mr-sc.tear .mr-pack{animation:mrdrop .5s ease-in .35s forwards}
.mr-card{transform-style:preserve-3d;transform:translateY(40px) rotateY(180deg) scale(.85);opacity:0}
.mr-sc.flip .mr-card{animation:mrflip .8s cubic-bezier(.2,.8,.2,1) forwards}
.mr-f,.mr-b{position:absolute;inset:0;border-radius:16px;backface-visibility:hidden;overflow:hidden}
.mr-b{transform:rotateY(180deg);background:linear-gradient(135deg,#2a2210,#e3b04b,#2a2210)}
.mr-f{background:#111;border:2px solid var(--gold,#e3b04b);box-shadow:0 0 50px rgba(227,176,75,.45)}
.mr-f img{width:100%;height:100%;object-fit:cover}
.mr-f::after{content:"";position:absolute;inset:-40%;background:linear-gradient(115deg,transparent 40%,rgba(255,255,255,.55) 50%,transparent 60%);transform:translateX(-100%);animation:mrshine 1.4s ease-out 1.1s}
.mr-nm{display:grid;gap:4px;opacity:0;transform:translateY(8px);transition:.35s .2s}
.mr-sc.done .mr-nm{opacity:1;transform:none}
.mr-nm b{font-family:var(--f-display,system-ui);font-size:24px;line-height:1.1;color:#fff}
.mr-nm span{font-size:13px;color:#d6d3cd}
.mr-nm em{font-style:normal;font-family:var(--f-mono,monospace);font-size:11px;color:var(--gold,#e3b04b);letter-spacing:.08em}
.mr-go{border:0;border-radius:999px;padding:12px 26px;background:var(--gold,#e3b04b);color:#000;font:inherit;font-weight:700;cursor:pointer;opacity:0;transition:opacity .3s .4s}
.mr-sc.done .mr-go{opacity:1}
.mr-hint{font-size:12.5px;color:#a19e99}
.mr-sc.tear .mr-hint{visibility:hidden}
@keyframes mrfoil{to{background-position:250% 250%}}
@keyframes mrshake{0%,100%{transform:rotate(0)}25%{transform:rotate(-4deg)}75%{transform:rotate(4deg)}}
@keyframes mrtear{to{transform:translate(70px,-160px) rotate(28deg);opacity:0}}
@keyframes mrdrop{to{transform:translateY(120px);opacity:0}}
@keyframes mrflip{0%{opacity:1;transform:translateY(40px) rotateY(180deg) scale(.85)}60%{transform:translateY(-14px) rotateY(-12deg) scale(1.04);opacity:1}100%{transform:none;opacity:1}}
@keyframes mrshine{to{transform:translateX(100%)}}
@media (prefers-reduced-motion:reduce){.mr-pack{animation:none}.mr-sc.tear .mr-top,.mr-sc.tear .mr-pack{animation:none;opacity:0}.mr-sc.flip .mr-card{animation:none;opacity:1;transform:none}.mr-f::after{display:none}}
.cl.gift.mr-rev small{color:var(--gold,#e3b04b)}
@media (max-height:720px){.mr-stage{width:150px;height:210px}.mr-pack b{font-size:64px}.mr-st{gap:12px}}
`;
  document.head.appendChild(css);

  let Q = [], busy = false;
  function play(r, i, n) {
    return new Promise(res => {
      const sc = document.createElement('div');
      sc.className = 'mr-sc'; sc.setAttribute('role', 'dialog'); sc.setAttribute('aria-modal', 'true'); sc.setAttribute('aria-label', 'Your free air freshener');
      sc.innerHTML = `<div class="mr-st"><span class="mr-eb">Deal unlocked${n > 1 ? ` · ${i + 1} of ${n}` : ''}</span>
<div class="mr-stage"><div class="mr-card"><div class="mr-b"></div><div class="mr-f"><img alt="" src="${r.s}"></div></div>
<button type="button" class="mr-pack" aria-label="Open your mystery pack"><span class="mr-top"></span><b>?</b><small>MYSTERY · AIR FRESHENER</small></button></div>
<span class="mr-hint">Tap the pack to open it</span>
<div class="mr-nm" aria-live="polite"><em>YOU PULLED</em><b></b><span>Free with your accessories · added to your cart</span></div>
<button type="button" class="mr-go">Nice, keep shopping</button></div>`;
      sc.querySelector('.mr-nm b').textContent = r.n;
      document.body.appendChild(sc);
      requestAnimationFrame(() => sc.classList.add('on'));
      let opened = false;
      const open = () => {
        if (opened) return; opened = true;
        sc.classList.add('tear');
        setTimeout(() => sc.classList.add('flip'), 450);
        setTimeout(() => { sc.classList.add('done'); sc.querySelector('.mr-go').focus(); }, 1250);
      };
      const auto = setTimeout(open, 1600);
      sc.querySelector('.mr-pack').addEventListener('click', () => { clearTimeout(auto); open(); });
      const close = () => { clearTimeout(auto); sc.classList.remove('on'); setTimeout(() => { sc.remove(); res(); }, 220); };
      sc.querySelector('.mr-go').addEventListener('click', close);
      sc.addEventListener('click', e => { if (e.target === sc && sc.classList.contains('done')) close(); });
      sc.addEventListener('keydown', e => { if (e.key === 'Escape') { if (!opened) open(); else close(); } });
      sc.querySelector('.mr-pack').focus();
    });
  }
  async function drain() {
    if (busy) return; busy = true;
    const n = Q.length;
    for (let i = 0; Q.length; i++) { const k = Q.shift(); await play(R[k], i, n); R[k].seen = 1; saveR(); paintAll(); }
    busy = false;
  }

  function sync(fromUser) {
    const m = mysCount(); let ch = false;
    for (let k = 0; k < m; k++) if (!R[k]) { R[k] = pick(); ch = true; }
    if (ch) saveR();
    if (!fromUser || window.INC_SEALED) return; // sealed: revealed on the Thank-you page instead
    for (let k = 0; k < m; k++) if (!R[k].seen && !Q.includes(k)) Q.push(k);
    if (Q.length) setTimeout(drain, 250);
  }

  /* ---------- show revealed designs instead of "revealed after purchase" ---------- */
  const SEALED_TXT = 'Sealed · revealed after checkout';
  function paintLines() {
    const box = $('clines'); if (!box) return;
    if (window.INC_SEALED) {
      box.querySelectorAll('.cl.gift').forEach(el => { const sm = el.querySelector('small'); if (sm && sm.textContent !== SEALED_TXT) sm.textContent = SEALED_TXT; });
      return;
    }
    let k = 0;
    box.querySelectorAll('.cl.gift').forEach(el => {
      const b = el.querySelector('b'); if (!b) return;
      if (!/mystery air freshener/i.test(b.textContent) && !el.classList.contains('mr-rev')) return;
      const r = R[k++]; if (!r || !r.seen) return;
      el.classList.add('mr-rev');
      const im = el.querySelector('.ct img'); if (im && r.s) im.src = r.s;
      b.textContent = r.n + ' air freshener';
      const sm = el.querySelector('small'); if (sm) sm.textContent = 'Mystery pull · free with your accessories';
    });
  }
  const og = window.gpick;
  window.gpick = function (el, n, P) {
    if (og) og.apply(this, arguments);
    if (!el || !n) return;
    if (window.INC_SEALED) { const s = el.querySelector('small'); if (s) s.textContent = 'Sealed · revealed after checkout · A$' + (7.95 * P.filter(x => x === 'm').length).toFixed(2) + ' value'; return; }
    const m = P.filter(x => x === 'm').length, got = R.slice(0, m).filter(r => r && r.seen);
    if (!got.length) { const s = el.querySelector('small'); if (s) s.textContent = 'Revealed when you unlock it · A$' + (7.95 * m).toFixed(2) + ' value'; return; }
    el.innerHTML = got.map(r => `<div class="mys"><img src="${r.s}" alt="" loading="lazy" decoding="async"><span><b></b><small>Your mystery pull · A$7.95 value</small></span><em class="mysf">FREE</em></div>`).join('');
    el.querySelectorAll('.mys b').forEach((b, i) => { b.textContent = got[i].n + ' air freshener'; });
    el.classList.add('done');
  };
  function paintAll() {
    paintLines();
    const X = window.CARTX; if (!X || !X.S) return;
    const S = X.S();
    ['cgpk', 'ugpk'].forEach(id => { const el = $(id); if (el && !el.hidden) window.gpick(el, el.id === 'cgpk' ? X.allowed() : S.g.length, S.g); });
  }
  const mo = new MutationObserver(() => { mo.disconnect(); paintLines(); obs(); });
  const obs = () => { const b = $('clines'); if (b) mo.observe(b, { childList: true }); };
  obs();

  // copy: the freshener is no longer a post-purchase surprise
  const fixCopy = () => document.querySelectorAll('small, .tc small, .xs, .lede, p, span').forEach(e => {
    if (e.children.length) return;
    if (/revealed after purchase/i.test(e.textContent)) e.textContent = e.textContent.replace(/revealed after purchase/ig, window.INC_SEALED ? 'revealed after checkout' : 'revealed when you unlock it');
    if (window.INC_SEALED && /revealed (when you unlock it|in your cart)/i.test(e.textContent)) e.textContent = e.textContent.replace(/(r)evealed (when you unlock it|in your cart)/ig, (m, r) => r + 'evealed after checkout');
  });

  // hook into the mock cart: after() calls INCSETCART every time the cart changes
  const hook = () => {
    const f = window.INCSETCART; if (!f || f.__mr) return !!f;
    const w = function () { const r = f.apply(this, arguments); try { sync(true); paintAll(); } catch (_) {} return r; };
    w.__mr = 1; window.INCSETCART = w; return true;
  };
  const boot = () => { if (!hook()) return setTimeout(boot, 300); sync(false); paintAll(); fixCopy(); };
  boot();
})();
